import axiosDeqart from 'api/axios';

// competitions
export const getCompetitions = async () => {
  try {
    const { data } = await axiosDeqart.get('/competitions');
    return data?.data.competitionsList;
  } catch (err) {
    console.log('An error occurred while fetching competitions data---', err.message);
    return err;
  }
};

export const getCompetition = (competitionId) => async () => {
  try {
    const { data } = await axiosDeqart.get(`/competitions/${competitionId}`);
    return data.data;
  } catch (err) {
    console.log(`An error occurred while fetching a competition with ${competitionId}`, err.message);
    throw err;
  }
};

export const joinCompetition = async (competitionId) => {
  try {
    const { data } = await axiosDeqart.patch(`/competitions/${competitionId}`);
    return data;
  } catch (err) {
    console.log(`An error occurred while fetching a competition with ${competitionId}`, err.message);
    throw err;
  }
};

export const getJoinedCompetitions = () => async () => {
  try {
    const { data: { data } } = await axiosDeqart.get('/users/me/competitions');
    return data;
  } catch (err) {
    console.log('An error occurred while fetching account data', err.message);
    throw err;
  }
};

// Leaderboard
export const getCompetitionLeaderBoard = (page, count, competitionId) => async () => {
  try {
    const leaderBoardUrlBase = `/competitions/${competitionId}/leaderboard`;
    const leaderBoardURl = `${leaderBoardUrlBase}?limit=${count}&offset=${page * count}`;
    const { data } = await axiosDeqart.get(leaderBoardURl);
    return {
      leaderBoard: data?.data || [],
      total: data?.totalCount || data?.data.length,
    };
  } catch (err) {
    console.log(`An error occurred while fetching a competition with ${competitionId}`, err.message);
    throw err;
  }
};

// Problems
export const getCompetitionProblems = (competitionId) => async () => {
  try {
    const { data: { data } } = await axiosDeqart.get(`/competitions/${competitionId}/problems`);
    return {
      problems: data?.problemsList || [],
      problemsLink: data?.problemsList[0]?.problemsLink || null,
    };
  } catch (err) {
    console.log('An error occurred while fetching account data', err.message);
    throw err;
  }
};
export const submitSolution = async (competitionId, problemId, answer, description) => {
  try {
    const { data } = await axiosDeqart.post(`/competitions/${competitionId}/problems/${problemId}/submissions`, {
      answer,
      description,
    });
    return {
      problemPoints: data?.data.points,
      timePenalty: data?.data.timePenalty,
      createdOn: data?.data.createdOn,
      submissionAnswer: answer,
      warningMessage: data?.data.warningMessage,
    };
  } catch (err) {
    console.log('An error occurred while submitting a solution', err.message);
    throw err;
  }
};
// Submissions

export const getCompetitionSubmissions = (competitionId) => async () => {
  try {
    const { data: { data } } = await axiosDeqart.get(`/competitions/${competitionId}/submissions`);
    const transformedData = Object.fromEntries(
      Object.entries(data?.submissionsByProblem || {}).map(([key, value]) => [key.toLowerCase(), value]),
    );
    return {
      submissions: transformedData || {},
    };
  } catch (err) {
    console.log('An error occurred while fetching account data', err.message);
    throw err;
  }
};
